import _ from "lodash";

const ERROR_STATUS_UNAUTHORIZED = 401;
const ERROR_STATUS_SERVER_ERROR = 500;

var ErrorUtils = {
  isRecoverableStatus: function (status) {
    var isRecoverable = true;

    switch (status) {
      case null:
      case ERROR_STATUS_SERVER_ERROR:
      case ERROR_STATUS_UNAUTHORIZED:
        isRecoverable = false;
        break;
    }

    return isRecoverable;
  },

  getFormattedError: function (err) {
    var error = {
      message: "Server Error",
      status: err.status,
    };

    if (err.status == ERROR_STATUS_SERVER_ERROR) {
      error.message = _.get(err, "message", "Server Error") + ": " + _.get(err, "request", "");
    } else {
      error.message = _.get(err, "message", "Server Error");
      if (_.has(err, "error")) {
        if (_.has(err.error, ["userMessage"])) {
          error.message = err.error.userMessage;
        } else if (_.has(err.error, ["message"])) {
          error.message = err.error.message;
        }

        if (_.has(err.error, ["detail"])) {
          error.message += ": " + err.error.detail;
        }

        if (_.has(err.error, ["fields"])) {
          error.fields = err.error.fields;
          if (_.size(error.fields) >= 1) {
            error.message += ": " + _.values(error.fields[0])[0];
          }
        }

        if (_.has(err.error, ["code"])) {
          error.message += " (" + err.error.code + ")";
          error.code = err.error.code;
        }

        _.merge(error, _.pick(err.error, ["data", "debug"]));
      }
      if (_.has(err, ["helpLink"])) {
        error.helpLink = err.helpLink;
      }
    }

    return error;
  },

  /**
   * Expects a formatted error from getFormattedError
   */
  hasFieldErrors(error) {
    return _.has(error, ["fields"]);
  },

  /**
   * Expects a formatted error from getFormattedError
   * Object return is used by PropertyInput error property
   */
  getFieldErrorMessage(error, name) {
    var message = _.get(error, ["fields", name], null);
    return message == null ? false : { message: message };
  },
};

export default ErrorUtils;
